// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container__3p6v7","body":"Detail_body__3rikZ","loading":"Detail_loading__3p9Hg","btn":"Detail_btn__dliyq"};